export function creditCardDialogOpened (billing) {
  if (billing && billing.card) {
    window.analytics.track('Credit Card Edit Clicked', {
      credit_card_brand: billing.card.brand
    })
  } else {
    window.analytics.track('Credit Card Add Clicked')
  }
}

export function creditCardDialogClosed () {
  window.analytics.track('Credit Card Dialog Closed')
}

export function creditCardAdded (billing) {
  window.analytics.track('Credit Card Added', {
    credit_card_brand: billing.card.brand
  })
}

export function creditCardErrored (billing, error) {
  let brand
  if (billing) {
    brand = billing.card.brand
  }

  window.analytics.track('Credit Card Errored', {
    credit_card_brand: brand,
    credit_card_error: error
  })
}



// WEBPACK FOOTER //
// ./analytics/credit-card.js